import { useMemo } from 'react';
export const useIconName = ({ type, icon }) => {
    const iconName = useMemo(() => {
        if (icon)
            return icon;
        switch (type) {
            case 'success':
                return 'check';
            case 'error':
                return 'warning';
            case 'info':
                return 'message';
            case 'warning':
                return 'warning';
        }
    }, [icon, type]);
    return iconName;
};
